import { classNames } from 'primereact/utils';
import LabeledValue from '~/components/ui/misc/LabeledValue';
import { FieldEditDetails } from '~/components/ui/document/dialogs/documentOverviewDialog/FieldEditDetails';
export function ExtractedField(props: {
  documentId: string;
  fieldName: string;
  fieldId: string;
  fieldValue: string | null;
  scrollToField: (s: string) => void;
  showActions: boolean;
  // deleteField: (fieldId: string) => void;
  type: 'clauses' | 'fields';
}) {
  return (
    <div className="extractedfield">
      {/* biome-ignore lint/a11y/useKeyWithClickEvents: Role and tabindex ought to be enough */}
      <div
        role="button"
        style={{ cursor: 'pointer', zIndex: 2000 }}
        tabIndex={0}
        className={classNames({
          fieldscrollto: true,
        })}
        onClick={(e) => {
          e.preventDefault();
          props.scrollToField(props.fieldId);
        }}
      >
        <LabeledValue title={props.fieldName}>{props.fieldValue}</LabeledValue>
      </div>

      {props.showActions !== undefined && <FieldEditDetails {...props} />}
    </div>
  );
}
